// @flow
import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { Box } from '@locus-taxy/neo-ui';

import useLatest from 'common/hooks/useLatest';

import Skeleton from 'platform/settings/modules/orchestration/components/Skeleton';

type Props = {
    onLoadMore: () => void,
    isLoading?: boolean
};

const LoadMore = ({ isLoading, onLoadMore }: Props): React.Node => {
    const { ref, inView } = useInView();
    const onLoadMoreRef = useLatest(onLoadMore);

    React.useEffect(() => {
        if (inView) {
            onLoadMoreRef.current();
        }
    }, [inView, onLoadMoreRef]);

    if (!isLoading) {
        return <Box ref={ref} height="1px" />;
    }

    return (
        <Box ref={ref}>
            <Skeleton height={30} borderRadius={4} count={2} />
        </Box>
    );
};

export default LoadMore;
